import axios from 'axios'
import { message } from 'antd'
import cookieOps from "./cookieOps";
import config from "../config";
import ERROR_MESSAGE from "../errorMessages";

let token = cookieOps.readCookie('mySweetApple')

const requestProvider = axios.create({
    baseURL: `${config.baseURL}`,
    headers: {
        'Authorization': `${token}`
    }
});

const cleanAuth = () => {
    localStorage.removeItem('name')
    localStorage.removeItem('surname')
    localStorage.removeItem('tenant');
    document.cookie = "mySweetApple=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

const handleErrMsg = (msg) => {
    const err = ERROR_MESSAGE["TR"][msg] || msg
    message.error(err);
}

requestProvider.interceptors.response.use((response) => {
    if (response.config.method !== 'get' &&
        !response.config.url.includes('login') &&
        !response.config.url.includes('purchase-new/detail')
    ) {
        message.success('İşlem başarılı.');
    }
    return response;
}, ({response}) => {

    if (response && response.status === 401) {
        message.error('Lütfen Yeniden Giriş Yapınız')
        cleanAuth();
        setTimeout(() => window.location = '/', 1)
        return response
    }

    handleErrMsg(response?.data?.message);
    throw response;
});


requestProvider.interceptors.request.use((request) => {
    if (request.url.includes('login')) {
        delete request.headers["Authorization"];
    }
    request.headers["tenantId"] = window.localStorage.getItem('tenant')

    return request;
}, (error) => {
    message.error('Bir hata meydana geldi.');
    throw error;
});

export default requestProvider